import { ApisauceInstance, create } from 'apisauce';
import { AxiosResponse } from 'axios';
import { toastr } from 'react-redux-toastr';
import { StatusOptions } from '../types';
import { ServerResponse } from '../api';
import { getAccessToken } from '../okta';

export interface CreateApiParams {
  baseURL: string;
  headers?: Record<string, string>;
  cacheTimeout?: number; // Reserved for future use
  hideMessage?: boolean;
  skipInterceptors?: boolean;
}

export function createApi(params: CreateApiParams): Promise<ApisauceInstance> {
  return getAccessToken().then((token: string) => {
    const apiSauceInstance = create({
      baseURL: params.baseURL,
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
        ...params.headers,
      },
    });

    if (!params.skipInterceptors) {
      apiSauceInstance.axiosInstance.interceptors.response.use(
        (response) => {
          handleResponse(response, !params.hideMessage);
          return response;
        },
        (error) => {
          if (error.message === 'Network Error') {
            toastr.error(error.message, 'You may not be connected to the Internet - or the Heal VPN.');
          } else {
            handleErrorResponse(error.response || {}, !params.hideMessage);
          }
          return error;
        }
      );
    }

    return apiSauceInstance;
  });
}

function handleResponse(response: AxiosResponse<ServerResponse>, showDefaultMessage?: boolean) {
  if (response.data.status !== StatusOptions.OK && response.status !== 200 && response.status !== 204) {
    if (response?.data?.description && response.data.status) {
      toastr.error(response.data.status || '', response.data.description);
    }
  } else if (response.config.method !== 'get') {
    if (showDefaultMessage) {
      const serverResponse = (response.data || {}) as ServerResponse;
      toastr.success(serverResponse.status || 'Success', serverResponse.description || '');
    }
  }
}

function handleErrorResponse(response: AxiosResponse<ServerResponse>, showDefaultMessage?: boolean) {
  if (showDefaultMessage) {
    const serverResponse = (response.data || {}) as ServerResponse;
    toastr.error(serverResponse.status || 'Error', serverResponse.description || 'Something went wrong.');
  }
}
